import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { apiFetch } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ResetPasswordPage() {
  const { token = "" } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [error, setError] = useState<string | null>(null);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await apiFetch("/api/auth/reset", { method: "POST", body: JSON.stringify({ token, newPassword: pw }) });
      void nav("/login");
    } catch { setError("Reset failed — link may be expired."); }
  }
  return <form onSubmit={(e) => void submit(e)} className="mx-auto mt-24 max-w-sm space-y-3">
    <h1 className="text-2xl font-semibold">Set a new password</h1>
    <Label htmlFor="pw">New password (min 12 chars)</Label>
    <Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={12} required />
    {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
    <Button type="submit">Set password</Button>
  </form>;
}
